type localesKeys__SkillsChart = {
  headLinkLabel__defaultText: string;
  headLabel__defaultText: string;
}

const ruLocale__SkillsChart: localesKeys__SkillsChart = {
    headLinkLabel__defaultText: 'Подробнее',
    headLabel__defaultText: 'Навыки'
};

const enLocale__SkillsChart: localesKeys__SkillsChart = {
  headLinkLabel__defaultText: 'More details',
  headLabel__defaultText: 'Skills'
};

export { ruLocale__SkillsChart, enLocale__SkillsChart };
export type { localesKeys__SkillsChart };